<app-auth-card-header>{{
  'ForgotPassword.Title' | translate
}}</app-auth-card-header>

<form [formGroup]="form" (ngSubmit)="submit()">
  <fieldset>
    <!-- Password-->
    <div>
      <mat-form-field
        style="width: 100%"
        class="password-field"
        [color]="passwordComponentWithValidation.color"
      >
        <mat-pass-toggle-visibility
          #toggleVisbility
          matSuffix
        ></mat-pass-toggle-visibility>
        <input
          matInput
          [formGroup]="form"
          [formControl]="password"
          controlName="password"
          name="password"
          [type]="toggleVisbility.type"
          #passwordWithValidation
          required
          placeholder="{{ 'Register.Password' | translate }}"
        />
        <mat-hint align="end" aria-live="polite">
          {{ passwordWithValidation.value.length }}
        </mat-hint>
        <mat-error
          *ngIf="password.hasError('required')"
          translate="Register.PasswordValidation.Required"
        >
        </mat-error>
        <mat-error
          *ngIf="password.hasError('pattern')"
          translate="Register.PasswordValidation.Invalid"
        >
        </mat-error>
      </mat-form-field>
      <mat-password-strength
        class="green"
        #passwordComponentWithValidation
        [password]="passwordWithValidation.value"
        [min]="8"
        [enableLengthRule]="true"
        [enableUpperCaseLetterRule]="true"
        [enableLowerCaseLetterRule]="true"
        [enableDigitRule]="true"
        [enableSpecialCharRule]="true"
      >
      </mat-password-strength>
      <mat-password-strength-info
        [passwordComponent]="passwordComponentWithValidation"
        [lowerCaseCriteriaMsg]="
          'Register.PasswordValidation.PasswordRequiresLower' | translate
        "
        [upperCaseCriteriaMsg]="
          'Register.PasswordValidation.PasswordRequiresUpper' | translate
        "
        [digitsCriteriaMsg]="
          'Register.PasswordValidation.PasswordRequiresDigit' | translate
        "
        [specialCharsCriteriaMsg]="
          'Register.PasswordValidation.PasswordRequiresNonAlphanumeric'
            | translate
        "
        [minCharsCriteriaMsg]="
          'Register.PasswordValidation.PasswordTooShort' | translate
        "
        [passwordComponent]="passwordComponent"
      >
        >
      </mat-password-strength-info>
    </div>

    <!--Confirmed Password-->
    <div>
      <mat-form-field style="width: 100%">
        <input
          matInput
          [formGroup]="form"
          [formControl]="confirmPassword"
          controlName="confirmPassword"
          type="password"
          required
          appConfirmEqualValidator="password"
          placeholder="{{ 'Register.ConfirmPassword' | translate }}"
        />
        <mat-error kj-error [control]="form.get('confirmPassword')"></mat-error>
      </mat-form-field>
    </div>

    <div class="divider divider-md"></div>

    <button
      mat-raised-button
      color="primary"
      class="float-right"
      role="button"
      type="submit"
      [disabled]="!form.valid"
    >
      {{ 'ForgotPassword.Button' | translate }}
    </button>
  </fieldset>
</form>

<app-auth-card-footer>
  <a [routerLink]="['/login']">{{ 'Login.Title' | translate }}</a>
  <!-- <span class="divider-h"></span> -->
</app-auth-card-footer>
